import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Modal } from "react-bootstrap";
import { FaCheckCircle } from "react-icons/fa";

const DonateModal = ({
  donateProject,
  setDonateProject,
  submitDonation,
  loading,
  success,
  setSuccess,
  errors,
}) => {
  const [expiredMessage, setExpiredMessage] = useState("");
  const nav = useNavigate();
  const FormSubmit = (e) => {
    e.preventDefault();
    nav("/contact-us");
  };

/**
  * Prevents default form submission and processes the donation.
  * @example
  * handleSubmit(event)
  * // Prevents default action and processes the event.
  * @param {Object} e - Event object for the form submission.
  * @returns {void} No return value.
  * @description
  *   - Calls 'submitDonation' with the event object.
  *   - It contains commented-out logic for setting an expired message, which is currently unused.
  */
  const handleSubmit = (e) => {
    e.preventDefault();
    submitDonation(e);

    // if (true) {
    //   setExpiredMessage(
    //     "This project is no longer accepting funds as its funding period has ended."
    //   );
    //   return;
    // }
    // setExpiredMessage(""); // Clear any previous error
    
  };

  return (
    <Modal
      className="fade modal-wrapper"
      id="modalDonate"
      show={!!donateProject}
      onHide={() => {
        setDonateProject(null);
        setSuccess(false);
        setExpiredMessage("");
      }}
      centered
    >
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">Choose your funding amount</h5>
          <button
            type="button"
            className="btn-close"
            onClick={() => {
              setDonateProject(null);
              setSuccess(false);
            }}
          >
            <i className="flaticon-close"></i>
          </button>
        </div>
        {success ? (
          <div style={{ textAlign: "center", padding: 15 }}>
            <div style={{ color: "green", fontSize: 40 }}>
              <FaCheckCircle />
            </div>
            <p style={{ marginBottom: 0, color: "black" }}>Thank you!</p>
            <small>We appreciate your support</small>

            <button
              type="button"
              className="btn btn-outline-primary btn-block mt-4"
              onClick={() => {
                setDonateProject(null);
                setSuccess(false);
              }}
            >
              Close
            </button>
          </div>
        ) : (
          <div className="modal-body">
            {expiredMessage && (
              <div style={{ color: "red", marginBottom: 20 }}>
                <strong>{expiredMessage}</strong>
              </div>
            )}

            {Object.keys(errors).length > 0 && (
              <div style={{ color: "red", marginBottom: 20 }}>
                <ul>
                  <li style={{ fontSize: 14 }}>
                    <strong>amount:</strong> {errors[0]}
                  </li>
                </ul>
              </div>
            )}
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-lg-12 mb-4">
                  <div className="form-group">
                    <label className="form-label mb-0">Amount</label>
                    <div className="input-group">
                      <input
                        type="number"
                        className="form-control"
                        placeholder="Enter Amount"
                        value={!!donateProject ? donateProject.amount : ""}
                        onChange={(e) =>
                          setDonateProject((prevData) => ({
                            ...prevData,
                            amount: e.target.value,
                          }))
                        }
                      />
                    </div>
                  </div>
                </div>

                <div className="col-lg-12">
                  <div className="form-group mb-0 text-center">
                    <button
                      name="submit"
                      type="submit"
                      value="Submit"
                      className="btn btn-primary btn-block"
                      disabled={loading}
                    >
                      {loading ? "Loading ..." : "Submit"}
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        )}
      </div>
    </Modal>
  );
};
export default DonateModal;
